<template lang="pug">
div
  h5 Transactions
  div(v-for='transaction in transactions')
    | {{transaction}}
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  props: ['transactions'],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Transactions.vue